import isObject from "lodash/isObject";

export const dataOrAll = <T>(data: T | T[]): T[] | "all" => {
  if (
    (isObject(data) && Object.keys(data).length) ||
    (Array.isArray(data) && data.length)
  ) {
    return data;
  }

  return "all";
};
